import script from "./CatalogServiceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogServiceModal.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogServiceModal.vue?vue&type=style&index=0&id=411814f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411814f3"]])

export default __exports__